import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { REGEX } from '@app/utils/constants/regex.constants';

export function stateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    if (!REGEX.shippingAddressAndState.test(value)) {
      return { invalidState: true };
    }

    return null;
  };
}
